// extracted by mini-css-extract-plugin
export var animationAbsolute = "_19-o";
export var animationRelative = "_19-n";
export var backdropBlur = "_19-0";
export var detailLabelCell = "_19-10";
export var detailTable = "_19-z";
export var detailValueCell = "_19-11";
export var docIconBox = "_19-19";
export var docTypeRow = "_19-14";
export var docTypeRowInner = "_19-15";
export var dropdownMatchDatePicker = "_19-1";
export var fileUploadSpin = "_19-h";
export var gorgiasOpenButton = "_19-13 _19-b";
export var gorgiasTicketCard = "_19-12";
export var heroModalFooterButton = "_19-16";
export var hiddenContainer = "_19-m";
export var maxWidthContainer = "_19-17";
export var modalContentBody = "_19-8";
export var modalHeaderImage = "_19-3";
export var modalImageLabel = "_19-5";
export var modalImageOverlay = "_19-4";
export var modalImageSubtitle = "_19-7";
export var modalImageTitle = "_19-6";
export var modalImageWrapper = "_19-2";
export var modalStickyFooter = "_19-9";
export var removeButton = "_19-c";
export var sidebarColumn = "_19-18";
export var spinner = "_19-g";
export var timelineLine = "_19-w";
export var timelineLineBlack = "_19-y _19-w";
export var timelineLineGray = "_19-x _19-w";
export var timelineLineHeight = "_19-v";
export var tlDotActivate = "_19-s";
export var tlDotActivateAnim = "_19-r";
export var tlDotHide = "_19-q";
export var tlDotHideAnim = "_19-p";
export var tlLineActivate = "_19-u";
export var tlLineActivateAnim = "_19-t";
export var uploadHint = "_19-l";
export var uploadIconBox = "_19-i";
export var uploadLabel = "_19-k";
export var uploadText = "_19-j";
export var uploadZone = "_19-d";
export var uploadZoneCursorDefault = "_19-f";
export var uploadZoneCursorPointer = "_19-e";
export var uploadedFileRow = "_19-a";
export var viewButton = "_19-b";